import {GanttChartStaticItem} from '@hconnect/ganttchart/src/modules/GanttChartStaticItem'
import {Icon} from '@hm/fundamental'
import {mdiFire} from '@mdi/js'

import {HotspotChartTooltip} from './HotspotChartTooltip'

import {Shutdown} from '@refra/modules/common/types'
import {HotSpot} from '@refra/modules/refra-planning/types'

const HOTSPOT_ITEM_WIDTH = 40
const HOTSPOT_ITEM_HEIGHT = 30

interface HotspotGanttChartItemProps {
  shutdown: Shutdown
  hotspot: HotSpot
  stepWidth: number
  onClick: () => void
}
export const HotspotChartItem = ({
  shutdown,
  hotspot,
  stepWidth,
  onClick
}: HotspotGanttChartItemProps) => (
  <GanttChartStaticItem
    key={`${shutdown.id}-${hotspot.id}-hotspot-item`}
    item={{
      id: hotspot.id.toString(),
      start: hotspot.meter * stepWidth - HOTSPOT_ITEM_WIDTH,
      end: hotspot.meter * stepWidth,
      label: (
        <div
          className={`w-[${HOTSPOT_ITEM_WIDTH}px] h-[${HOTSPOT_ITEM_HEIGHT}px] border-negative border rounded bg-negative_faded_20_selected flex justify-center items-center cursor-pointer`}
        >
          <Icon path={mdiFire} size="large" className="text-negative" />
        </div>
      ),
      height: HOTSPOT_ITEM_HEIGHT,
      tooltip: {
        tooltipContent: <HotspotChartTooltip hotspot={hotspot} />
      },
      testPrefix: 'hotspot-'
    }}
    rowHeight={HOTSPOT_ITEM_WIDTH}
    rowPadding={10}
    stepWidth={stepWidth}
    mutationKey={'editKilnReplacement'}
    onItemClick={() => onClick()}
  />
)
